var map = {
	"./arg.svg": 927,
	"./aus.svg": 928,
	"./bel.svg": 929,
	"./bra.svg": 930,
	"./can.svg": 931,
	"./cmr.svg": 932,
	"./crc.svg": 933,
	"./cro.svg": 934,
	"./den.svg": 935,
	"./ecu.svg": 936,
	"./eng.svg": 937,
	"./esp.svg": 938,
	"./fra.svg": 939,
	"./ger.svg": 940,
	"./gha.svg": 941,
	"./irn.svg": 942,
	"./jpn.svg": 943,
	"./kor.svg": 944,
	"./ksa.svg": 945,
	"./mar.svg": 946,
	"./mex.svg": 947,
	"./ned.svg": 948,
	"./pol.svg": 949,
	"./por.svg": 950,
	"./qat.svg": 951,
	"./sen.svg": 952,
	"./srb.svg": 953,
	"./sui.svg": 954,
	"./tun.svg": 955,
	"./uru.svg": 956,
	"./usa.svg": 957,
	"./wal.svg": 958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;